export default {
  "content": "<g clip-path=\"url(#icon_lightning_filled_svg__a)\"><path d=\"M6.55 9.39l.04-.66H2.5c-.4 0-.64-.45-.41-.78L7.51.21c.28-.4.9-.2.9.28v5.76h4.63c.41 0 .64.46.4.79l-6.38 8.75c-.29.4-.93.17-.9-.32l.39-6.08z\"/></g><defs><clipPath id=\"icon_lightning_filled_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};